import { Provider } from '@angular/core';

import { GetGuardJobDetails } from '../Domain/Port/GetGuardJobDetails/get-guard-job.details';
import { BackendGetGuardJobDetailsService } from '../Infrastructure/Adapter/GetGuardJobDetails/backend-get-guard-job-details.service';

export const provideGetGuardJobDetails = (): Provider[] => {
    return [
        {
            provide: GetGuardJobDetails,
            useExisting: BackendGetGuardJobDetailsService
        }
    ];
};
